module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [(_vm.isPeru && _vm.isCreditCard) ? _c('section', {
    staticClass: "d-flex align-center section-authorization",
    style: (("border-top: 0.1rem solid " + (_vm.globalColors.primary) + ";"))
  }, [_c('img', {
    attrs: {
      "src": _vm.svg.visa,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txt-center text-principal"
  }, [_vm._v("Esta tienda está autorizada por Visa para realizar transacciones electrónicas.")])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "d-flex wrap space-between suscribe-address"
  }, [_c('div', {
    staticClass: "d-flex justify-start wraper-address align-start wrap"
  }, [_vm._l((_vm.storesComputed), function(store, indexStore) {
    return _c('div', {
      key: indexStore,
      staticClass: "d-flex align-start information-company"
    }, [_c('location-svg', {
      staticClass: "img-location",
      attrs: {
        "primary": ""
      }
    }), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(store.name) + ":")]), _vm._v("\n\t\t\t\t\t " + _vm._s(store.address) + "\n\t\t\t\t")])], 1)
  }), _vm._v(" "), (_vm.showBtn && _vm.warehouses.length > 3) ? _c('button', {
    staticClass: "see-more-btn",
    style: (("color: " + (_vm.globalColors.primary))),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.seeMoreBtnClicked
    }
  }, [_vm._v("Ver más...")]) : _vm._e()], 2)]), _vm._v(" "), _c('section', {
    staticClass: "footer-info d-flex space-evenly wrap"
  }, [_c('div', {
    staticClass: "flex-50 d-flex align-start wrapper-numbers"
  }, [_c('div', {
    staticClass: "d-flex align-center wrapper-image"
  }, [_c('HeadPhones', {
    staticClass: "head-phones"
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mb-2"
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": "/static/img/icons/email-footer.svg",
      "alt": "email"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "email-store",
    style: (("color:" + (_vm.globalColors.titulo))),
    attrs: {
      "href": _vm.mailTo
    }
  }, [_vm._v(_vm._s(_vm.getCommerceData.email))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": "/static/img/icons/phone-footer.svg",
      "alt": "telefono"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getCommerceData.phone))])])])]), _vm._v(" "), _vm._l((_vm.contents), function(content, indexContent) {
    return _c('div', {
      key: indexContent,
      staticClass: "flex-25 mb-2 wrapper-list"
    }, [_c('h4', {
      staticClass: "title-column m0"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(content.name) + "\n\t\t\t")]), _vm._v(" "), _vm._l((content.items), function(item) {
      return _c('ul', {
        key: item.id,
        staticClass: "list-container mt-2"
      }, [_c('li', {
        staticClass: "pointer",
        on: {
          "click": function($event) {
            _vm.goToHelp(content, item)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t")])])
    })], 2)
  })], 2), _vm._v(" "), (_vm.isPeru && _vm.isCreditCard) ? _c('section', {
    staticClass: "social-media mb-2"
  }, _vm._l((_vm.cards), function(card, index) {
    return _c('div', {
      key: index,
      staticClass: "social"
    }, [_c('img', {
      staticClass: "credit-card",
      attrs: {
        "src": card.image,
        "alt": card.name,
        "height": card.height
      }
    })])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-30 txt-center wrapper-social-desktop"
  }, [_c('img', {
    attrs: {
      "src": _vm.svg.facebook,
      "alt": "facebook"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.svg.google,
      "alt": "google"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "qtc-rights d-flex align-center justify-center",
    style: (("border-top: 0.1rem solid " + (_vm.globalColors.primary) + ";"))
  }, [_c('a', {
    attrs: {
      "href": "https://apprunn.com/",
      "target": "_blank"
    }
  }, [_vm._v("\n\t\t\t© 2019 apprunn.com. Todos los derechos reservados.\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-social"
  }, _vm._l((_vm.getCommerceData.socialNetworks), function(social, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": social.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": social.logo,
        "alt": "logo de redes sociales"
      }
    })])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfc3affc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sections/Footer.vue
// module id = 533
// module chunks = 4 5 27